const OPERACOES_COM_TRATAMENTO_PROPRIO = ["login", "loginPorTicket", "SolicitarIntegracaoSistema", "SolicitarHomologacaoSistema"];

export const exibeErroGlobal = (operationName: string | undefined): boolean =>
  !operationName || !OPERACOES_COM_TRATAMENTO_PROPRIO.includes(operationName);
